export const ERROR_TYPE = {
  errorMessage: 'errorMessage',
  errorMessageForColor: 'errorMessageForColor',
};
